export const navLinks = [
  { id: "overview", label: "内容速览" },
  { id: "story", label: "作品背景" },
  { id: "novel", label: "小说" },
  { id: "comic", label: "漫画" },
  { id: "fan", label: "同人" },
  { id: "extra", label: "番外" },
  { id: "season", label: "第二季与续集" },
  { id: "similar", label: "找同款" },
  { id: "guide", label: "阅读指南" },
];

export const heroHighlights = [
  { icon: "ri-book-2-line", label: "小说", desc: "正传 · 番外 · 试读" },
  { icon: "ri-gallery-line", label: "漫画", desc: "条漫 · 分镜 · 上色" },
  { icon: "ri-quill-pen-line", label: "同人", desc: "小说 · 图 · 广播剧" },
  { icon: "ri-film-line", label: "第二季 / 续集", desc: "走向 · 时间线" },
];

export const quickAccess = [
  {
    id: "novel",
    icon: "ri-book-2-line",
    title: "小说专区",
    desc: "按主线、感情线与轻日常分流整理，快速定位想读的部分。",
    count: "5 类阅读入口",
  },
  {
    id: "comic",
    icon: "ri-gallery-line",
    title: "漫画改编",
    desc: "条漫、分镜稿、上色版与封面图集的查找方向。",
    count: "4 个方向",
  },
  {
    id: "fan",
    icon: "ri-quill-pen-line",
    title: "同人创作",
    desc: "同人小说、同人图、广播剧与剪辑手书的整理索引。",
    count: "5 类作品",
  },
  {
    id: "extra",
    icon: "ri-file-text-line",
    title: "番外合集",
    desc: "甜向、日常、角色视角与节日番外的分类说明。",
    count: "5 类番外",
  },
  {
    id: "season",
    icon: "ri-tv-2-line",
    title: "第二季与续集",
    desc: "厘清第二季、续集与同名版本之间的区别与查找顺序。",
    count: "5 个问题",
  },
  {
    id: "similar",
    icon: "ri-compass-3-line",
    title: "找同款",
    desc: "按题材标签筛选相似方向的衍生作品，一键缩小范围。",
    count: "8 条方向",
  },
];

export const storyTags = ["都市", "家庭关系", "情感纠葛", "轻喜剧", "长篇连载", "生活流"];

export const storyPoints = [
  {
    icon: "ri-home-heart-line",
    title: "一个围绕家庭关系展开的都市故事",
    desc: "《漂亮的小姨子》通常被归类为都市家庭情感题材，故事推进多发生在日常生活场景中，人物关系是推动情节的主要动力。",
  },
  {
    icon: "ri-git-branch-line",
    title: "多条情感线并行",
    desc: "主线之外往往同时铺开若干条感情支线，不同读者会按自己关注的 CP 或人物线选择阅读顺序，这也是衍生内容特别多的原因之一。",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "冲突与轻松日常交替",
    desc: "紧张的情感矛盾之后常安排较为轻松的生活化段落，节奏张弛交替，适合喜欢连续追读的读者。",
  },
  {
    icon: "ri-stack-line",
    title: "衍生内容体量庞大",
    desc: "正传之外，同人、番外、续写与改编版本数量不少，按类别整理能明显降低查找成本。",
  },
];

export const novelEntries = [
  {
    id: "novel-main",
    icon: "ri-book-open-line",
    title: "主线正传",
    subtitle: "完整剧情线，适合从头梳理",
    desc: "以完整故事发展为主，按章节顺序推进主线冲突与人物成长，适合第一次接触该题材、希望一次性了解整体脉络的读者。",
    tags: ["剧情向", "顺序阅读", "长篇"],
    meta: "阅读建议：从第一章开始顺序阅读",
  },
  {
    id: "novel-romance",
    icon: "ri-heart-2-line",
    title: "感情线合集",
    subtitle: "聚焦人物之间的情感推进",
    desc: "把与主要人物感情发展相关的章节单独抽出来，方便只关心情感走向的读者跳读，也常被用来回顾某条 CP 线的发展节点。",
    tags: ["感情向", "CP 线", "跳读友好"],
    meta: "阅读建议：按人物线分组浏览",
  },
  {
    id: "novel-slice",
    icon: "ri-cup-line",
    title: "轻松日常向",
    subtitle: "弱化冲突，篇幅偏生活化",
    desc: "冲突较少、节奏平缓的段落集合，多为餐桌、通勤、周末等日常场景，适合睡前或碎片时间阅读，也是很多读者的入门选择。",
    tags: ["日常流", "轻松", "治愈"],
    meta: "阅读建议：任意段落独立可读",
  },
  {
    id: "novel-extra",
    icon: "ri-file-text-line",
    title: "番外合集",
    subtitle: "正文之外的补充篇章",
    desc: "正传结束后或穿插其中的补充内容，通常包括不同角色视角、时间线跳转与节日特辑，建议在读完对应主线后再打开。",
    tags: ["补充篇", "角色视角", "彩蛋"],
    meta: "阅读建议：读完主线后食用更佳",
  },
  {
    id: "novel-short",
    icon: "ri-speed-line",
    title: "短篇试读",
    subtitle: "篇幅短，先感受文风",
    desc: "篇幅较短的独立片段，用来快速判断叙事风格、人物设定与语言习惯是否对胃口，避免直接投入长篇后发现不对味。",
    tags: ["试读", "短篇", "入门"],
    meta: "阅读建议：不确定是否入坑时先看这个",
  },
];

export const comicEntries = [
  {
    id: "comic-webtoon",
    icon: "ri-smartphone-line",
    title: "条漫版本",
    subtitle: "竖屏滑动阅读",
    desc: "以竖版条漫形式呈现，适合手机端上下滑动阅读，分镜节奏偏快，多用于改编短篇与日常段落。",
    tags: ["竖屏", "手机友好"],
  },
  {
    id: "comic-boards",
    icon: "ri-layout-masonry-line",
    title: "分镜稿合集",
    subtitle: "过程稿与草稿",
    desc: "收录改编过程中的分镜与线稿，能看到同一情节在不同分镜方案下的差异，对喜欢研究画法的读者更有价值。",
    tags: ["过程稿", "分镜"],
  },
  {
    id: "comic-color",
    icon: "ri-palette-line",
    title: "上色完整版",
    subtitle: "成稿与全彩版",
    desc: "完成上色与后期处理的成稿版本，画面信息更完整，适合作为收藏或壁纸素材来源。",
    tags: ["全彩", "成稿"],
  },
  {
    id: "comic-cover",
    icon: "ri-image-2-line",
    title: "封面与图集",
    subtitle: "单幅插画汇总",
    desc: "把散落的单幅封面、章节插画与宣传图集中整理，便于按场景或角色查找，通常附带构图说明。",
    tags: ["插画", "合集"],
  },
];

export const fanEntries = [
  {
    id: "fan-novel",
    icon: "ri-quill-pen-line",
    title: "同人小说",
    subtitle: "读者的二次创作",
    desc: "由读者基于原作人物与设定进行的再创作，常见分支包括平行世界观、结局改写与配角视角补完，题材因此相当发散。",
    tags: ["二次创作", "改写"],
  },
  {
    id: "fan-art",
    icon: "ri-brush-line",
    title: "同人图",
    subtitle: "插画与角色立绘",
    desc: "以角色立绘、场景插画与关系图为主，风格从写实到 Q 版差异很大，通常按角色或场景主题归类浏览。",
    tags: ["插画", "立绘"],
  },
  {
    id: "fan-audio",
    icon: "ri-mic-line",
    title: "广播剧 / 有声",
    subtitle: "声音演绎版本",
    desc: "将文字内容改编为有声演绎，包含对白剧与旁白剧两种形式，适合通勤或做家务时收听。",
    tags: ["有声", "广播剧"],
  },
  {
    id: "fan-video",
    icon: "ri-movie-2-line",
    title: "剪辑与手书",
    subtitle: "视频化二次创作",
    desc: "以剪辑视频、动态手书为主的视频化创作，通常围绕某一情节或人物做情感向表达，时长较短、传播性强。",
    tags: ["剪辑", "手书"],
  },
  {
    id: "fan-setting",
    icon: "ri-node-tree",
    title: "设定考据",
    subtitle: "人物与时间线整理",
    desc: "由读者整理的人物关系表、时间线与设定考据，用于厘清复杂的人物网络，是阅读长篇时的实用辅助资料。",
    tags: ["考据", "关系表"],
  },
];

export const extraEntries = [
  {
    id: "extra-sweet",
    icon: "ri-heart-3-line",
    title: "甜向番外",
    subtitle: "把遗憾补成圆满",
    desc: "以温馨互动和圆满结局为主，多为正传中错过或留白的片段补充，读起来轻松，适合想缓冲情绪时打开。",
    tags: ["甜", "圆满", "轻松"],
  },
  {
    id: "extra-daily",
    icon: "ri-home-4-line",
    title: "日常番外",
    subtitle: "琐碎但有人情味",
    desc: "围绕吃饭、搬家、过节等琐事展开，几乎没有强冲突，靠细节和对白撑起趣味，是篇幅最零散的一类。",
    tags: ["日常", "生活流"],
  },
  {
    id: "extra-continue",
    icon: "ri-contract-line",
    title: "续写番外",
    subtitle: "正文之后的延伸",
    desc: "延续正传时间线继续推进，可能涉及人物关系的新阶段，阅读前建议先确认其承接的是哪一版结局。",
    tags: ["续写", "承接"],
  },
  {
    id: "extra-pov",
    icon: "ri-eye-line",
    title: "角色视角番外",
    subtitle: "换一个人称看同一段",
    desc: "用配角或另一主角的视角重写关键情节，能补全原叙述中未交代的心理活动，常被当作理解人物的补充材料。",
    tags: ["视角切换", "补完"],
  },
  {
    id: "extra-festival",
    icon: "ri-calendar-event-line",
    title: "节日特辑",
    subtitle: "按日期发布的小短篇",
    desc: "在春节、中秋、情人节等节点发布的小短篇，彼此独立、不接主线，通常按年份或节日归类查找。",
    tags: ["节日", "独立短篇"],
  },
];

export const seasonEntries = [
  {
    id: "season-2",
    icon: "ri-tv-2-line",
    title: "第二季讲什么",
    desc: "第二季一般是正传故事线的延续，承接第一季留下的悬念，重点在于人物关系的进一步推进，具体情节以对应来源的更新为准。",
    tags: ["延续", "承接悬念"],
  },
  {
    id: "season-sequel",
    icon: "ri-refresh-line",
    title: "续集与第二季是一回事吗",
    desc: "不完全一样。第二季偏向同一作品的分季更新，续集则可能是同世界观下的新故事或新标题，查找时建议先确认是分季还是全新篇章。",
    tags: ["概念区分"],
  },
  {
    id: "season-timeline",
    icon: "ri-timeline-view",
    title: "续集时间线怎么排",
    desc: "正确的顺序通常是正传 → 番外 → 第二季/续集，但部分续集采用独立时间线，阅读前先看开头的衔接说明可减少混乱。",
    tags: ["时间线", "阅读顺序"],
  },
  {
    id: "season-newchar",
    icon: "ri-user-add-line",
    title: "新角色与新支线",
    desc: "续作常引入新角色以展开新的矛盾，同时保留一部分原班人马，新老角色之间的比例会影响整体观感。",
    tags: ["新角色", "新支线"],
  },
  {
    id: "season-version",
    icon: "ri-stack-line",
    title: "同名不同版本怎么分",
    desc: "同名作品可能存在小说版、漫画版与不同连载来源，区分方法是看更新来源、章节编号与作者署名，避免把两个版本混着读。",
    tags: ["版本区分", "避坑"],
  },
];

export const similarTags = ["全部", "都市", "家庭", "情感", "轻喜剧", "治愈", "逆袭", "群像"];

export const similarItems = [
  {
    id: "sim-1",
    icon: "ri-building-2-line",
    title: "都市家庭关系型",
    desc: "以城市生活为舞台，围绕一个家庭内部的关系变化展开，情节靠人物互动推动，适合喜欢慢热铺陈的读者。",
    tags: ["都市", "家庭"],
    match: "95%",
  },
  {
    id: "sim-2",
    icon: "ri-emotion-normal-line",
    title: "多角情感纠葛型",
    desc: "几条感情线彼此交叉，人物的选择构成主要悬念，阅读时按 CP 线跟进会更有条理。",
    tags: ["情感", "群像"],
    match: "92%",
  },
  {
    id: "sim-3",
    icon: "ri-restaurant-line",
    title: "轻喜剧生活流型",
    desc: "冲突被淡化，笑点和日常细节为主，适合想要轻松解压、不追求强情节的读者。",
    tags: ["轻喜剧", "治愈"],
    match: "90%",
  },
  {
    id: "sim-4",
    icon: "ri-sun-line",
    title: "温情治愈型",
    desc: "重情绪抚慰与关系的缓慢修复，节奏偏慢，通常在结尾给出较为温和的收束。",
    tags: ["治愈", "情感"],
    match: "88%",
  },
  {
    id: "sim-5",
    icon: "ri-rocket-2-line",
    title: "小人物逆袭型",
    desc: "主角从被动处境逐步掌握主动，成长曲线清晰，爽点集中在处境的反转上。",
    tags: ["逆袭", "都市"],
    match: "86%",
  },
  {
    id: "sim-6",
    icon: "ri-group-line",
    title: "群像叙事型",
    desc: "没有绝对单一主角，多条人物线交叉推进，适合喜欢同时追踪多组关系的读者。",
    tags: ["群像", "家庭"],
    match: "84%",
  },
  {
    id: "sim-7",
    icon: "ri-emotion-laugh-line",
    title: "欢喜冤家型",
    desc: "以先误会后和解为主要模式，对话密集、互动感强，节奏轻快。",
    tags: ["轻喜剧", "情感"],
    match: "82%",
  },
  {
    id: "sim-8",
    icon: "ri-home-smile-line",
    title: "同居磨合型",
    desc: "围绕同一屋檐下的相处展开，靠生活习惯的差异制造摩擦与笑料，场景集中。",
    tags: ["都市", "治愈"],
    match: "80%",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先确认想看的类型",
    desc: "是读小说、看漫画，还是找同人？先定类别，再进对应分区，能省掉大量来回翻找的时间。",
  },
  {
    step: "02",
    title: "再判断是正传还是衍生",
    desc: "正传按顺序读，番外和续写建议读完主线再打开；分不清时先看条目开头的衔接说明。",
  },
  {
    step: "03",
    title: "最后按标签缩小范围",
    desc: "在“找同款”里勾选题材标签，把相似方向的条目筛出来，再逐条判断是否符合口味。",
  },
];

export const faqs = [
  {
    q: "本站主要提供什么内容？",
    a: "本站是一个围绕《漂亮的小姨子》衍生内容的整理与导航页面，把小说、漫画、同人、番外以及第二季、续集相关信息按类别归拢，帮助读者按同一方向快速找到想看的部分。",
  },
  {
    q: "小说、漫画和同人有什么区别？",
    a: "小说指以文字连载为主的原始与改编版本；漫画是以图像分镜呈现的改编形式；同人则是读者基于原作人物与设定进行的二次创作，三者的创作主体与阅读方式都不同。",
  },
  {
    q: "第二季和续集是同一种东西吗？",
    a: "不是。第二季通常指同一作品的分季延续更新，续集则可能是同世界观下的新篇章或新标题。查找时建议先确认它属于分季还是全新故事，以免阅读顺序错乱。",
  },
  {
    q: "为什么不同来源的信息会不一致？",
    a: "同一题材可能存在多个连载来源与改编版本，章节排序、更新进度和命名习惯都可能不同。遇到冲突时，以更新来源、章节编号与作者署名为准，不要混着读。",
  },
  {
    q: "不懂从哪里开始读怎么办？",
    a: "可以先看“小说专区”里的短篇试读，确认文风是否合适，再回到主线正传按顺序阅读；如果只是想轻松跟读日常段落，也可以直接从轻松日常向的条目进入。",
  },
  {
    q: "内容适合所有读者吗？",
    a: "该题材属于都市家庭情感方向，不同版本的表达尺度存在差异。页面仅做信息整理与分类，不提供具体作品内容，请读者自行判断是否适合，并遵守所在平台的相关规定。",
  },
];

export const footerColumns = [
  {
    title: "内容分区",
    links: [
      { id: "novel", label: "小说专区" },
      { id: "comic", label: "漫画改编" },
      { id: "fan", label: "同人创作" },
      { id: "extra", label: "番外合集" },
    ],
  },
  {
    title: "查找帮助",
    links: [
      { id: "story", label: "作品背景" },
      { id: "season", label: "第二季与续集" },
      { id: "similar", label: "找同款" },
      { id: "guide", label: "阅读指南" },
    ],
  },
];